module.exports = __webpack_public_path__ + "img/logo-kr.c5d853ae.png";